<template>
  <b-tabs
    v-if="value"
    pills
    :content-class="{
      'mt-2': !embedded,
      'mb-4': true
    }"
    :nav-wrapper-class="{
      'd-none': embedded
    }">
    <b-tab active>
      <template slot="title">
        Generale
        <b-badge variant="danger"
          v-if="countErrors()">
          {{ countErrors() }}
        </b-badge>
      </template>
      <form>
        <div class="row">
          <string-form-field
            class="col-md-6"
            label="Nome"
            required
            :value="value.firstName"
            :disabled="disabled"
            :error="findError('firstName')"
            @input="propertyChanged('firstName', $event)"
          />

          <string-form-field
            class="col-md-6"
            label="Cognome"
            required
            :value="value.lastName"
            :disabled="disabled"
            :error="findError('lastName')"
            @input="propertyChanged('lastName', $event)"
          />
        </div>

        <div class="row">
          <string-form-field
            class="col-md-6"
            label="Username"
            required
            :value="value.username"
            :disabled="disabled"
            :error="findError('username')"
            @input="propertyChanged('username', $event)"
          />

          <string-form-field
            class="col-md-6"
            label="E-mail"
            required
            :value="value.email"
            :disabled="disabled"
            :error="findError('email')"
            @input="propertyChanged('email', $event)"
          />
        </div>
      </form>
    </b-tab>
  </b-tabs>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';

export default {
  mixins: [ EntityEditorMixin ],

  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  }
}
</script>
